class ProductComparison {
  constructor() {
    this.queryParams = 0;
    this.selectedPids = [];
    this.newUrl = '';
    
    const urlParamsCompare = new URLSearchParams(window.location.search);
    const vidsParam = urlParamsCompare.get("vids");
    if (vidsParam) {
      this.queryParams = vidsParam.split(",").length;
    }

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleClearAllClick = this.handleClearAllClick.bind(this);
    this.handleCompareFooterClick = this.handleCompareFooterClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleMutation = this.handleMutation.bind(this);

    this.initialize();
    document.querySelector('.customBackDiv' )?.setAttribute('href', document.referrer);
  }
  headerTopHeight(){
    window.addEventListener('scroll', function () {
      const header = document.querySelector('.header-sticky');
      const isMobile = window.innerWidth <= 1200;
      const tableContent = document.querySelector(
        isMobile ? '.compare-table-main-content' : '.desktop-compare-product-title'
      );
    
      if (header && tableContent && !header.classList.contains('header-hidden')) {
        tableContent.style.top = `${header.offsetHeight}px`;
      } else if (tableContent) {
        tableContent.style.top = isMobile ? '0px' : '0px';
      }
    });
    

  }

  updateURL() {
    console.log(this.selectedPids, 'selectedPids');
    
    if (window.location.href.includes('?sort_by=') || window.location.href.includes('?variant')) {
      const queryString = this.selectedPids.length ? `&vids=${this.selectedPids.join(",")}` : "";
      const url = new URL(window.location.href);
      url.searchParams.delete("vids");
      this.newUrl = url.origin + url.pathname + url.search + queryString;
    } else {
      if (window.location.search === '' || window.location.href.includes('?vids=')) {
        const queryString = this.selectedPids.length ? `?vids=${this.selectedPids.join(",")}` : "";
        this.newUrl = window.location.origin + window.location.pathname + queryString;
      }
    }

    window.history.replaceState(null, "", this.newUrl);

    const compareButton = document.querySelector(".CompareFooter__Button");
    
    if (compareButton) compareButton.href = 'pages/compare?' + this.newUrl.split('?')[1];
  }

  toggleCompareButton() {
    const compareButton = document.querySelector('.CompareFooter__Button');
    if (window.location.href.includes('vids=')) {
      compareButton?.classList.remove('d-none');
    } else {
      compareButton?.classList.add('d-none');
    }
  }

  handleClearAllClick() {
    const url = new URL(window.location);
    url.searchParams.delete("vids");
    window.history.replaceState({}, document.title, url.pathname + url.search);
    document.querySelector('.CompareFooter__Button').classList.add('d-none');
    this.initializeFromURL();
  }

  handleCheckboxChange(event) {
    const pid = event.target.getAttribute("pid");
    if (event.target.checked) {
      if (this.selectedPids.length < 3) this.selectedPids.push(pid);
    } else {
      this.selectedPids = this.selectedPids.filter(id => id !== pid);
    }

    document.querySelectorAll("#compareCheck").forEach(el => el.disabled = this.selectedPids.length >= 3 && !el.checked);
    this.updateURL();
    if (document.querySelector('.selectedCount')) document.querySelector('.selectedCount').innerHTML = this.selectedPids.length;
    this.toggleCompareButton();
  }

  initializeFromURL() {

    const urlParamsCompare = new URLSearchParams(window.location.search);
    this.selectedPids = urlParamsCompare.get("vids") ? urlParamsCompare.get("vids").split(",") : [];

    document.querySelectorAll("#compareCheck").forEach(cb => {
      cb.checked = this.selectedPids.includes(cb.getAttribute("pid"));
      cb.removeEventListener("change", this.handleCheckboxChange);
      cb.addEventListener("change", this.handleCheckboxChange);
    });

    document.querySelectorAll("#compareCheck").forEach(el => el.disabled = this.selectedPids.length >= 3 && !el.checked);

    this.updateURL();
    if (document.querySelector('.selectedCount')) document.querySelector('.selectedCount').innerHTML = this.selectedPids.length;
  }

  handleCompareFooterClick() {
    console.log('clicked');
    const urlParamas = new URLSearchParams(window.location.search);
    const vides = urlParamas.get('vids');
    window.location.href = window.location.origin + '/pages/compare?vids=' + vides;
  }

  setupMutationObserver() {
    const targetNode = document.getElementById('collection-container');
    if (targetNode) {
      const config = { attributes: true, childList: true, subtree: true };
      this.observer = new MutationObserver(this.handleMutation);
      this.observer.observe(targetNode, config);
    }
  }

  handleMutation() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.observer.disconnect();
      this.initializeFromURL();
      this.toggleCompareButton();
      this.observer.observe(document.getElementById('collection-container'), { attributes: true, childList: true, subtree: true });
    }, 100);
  }

  safeParseJSON(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      console.error("Error parsing JSON:", e);
      return null;
    }
  }

  getPriceRange(product) {
    const edges = product.variants?.edges;
    if (!edges || edges.length === 0) return "N/A";

    const firstVariant = edges[0].node;
    const price = firstVariant.priceV2?.amount ?? "N/A";
    const compareAt = firstVariant.compareAtPriceV2?.amount ?? null;

    const priceInt = parseInt(price, 10);
    const compareAtInt = compareAt ? parseInt(compareAt, 10) : null;
    let priceText = `<span class='${compareAtInt && compareAt > priceInt ? "text-dark-orange" : ""}'>$${priceInt}</span>`;
    console.log(price, compareAt , 'priceInt');
    
    if (compareAt && parseFloat(compareAt) > priceInt) {
      priceText += ` <del class='del'>$${Math.floor(parseFloat(compareAt))}</del>`;
    }
    return priceText;
  }

  getColors(product) {
    if (!product.options) return "N/A";
    
    // Find the color option in the product's options
    const colorOption = product.options.find(opt => opt.name.toLowerCase() === "color");
    if (!colorOption || !colorOption.values) return "N/A";
  
    const colorMap = JSON.parse(document.querySelector('[data-swatches-colorlist-json]').textContent);
  
    const availableColors = colorOption.values.filter(color => {
      const variant = product.variants.edges.find(edge => 
        edge.node.selectedOptions.some(opt => 
          opt.name.toLowerCase() === "color" && opt.value === color
        )
      );
      return !variant || !variant.node.hideVariant || variant.node.hideVariant.value !== "true";
    });
  
    if (availableColors.length === 0) return "N/A";
  
  
    const colorSpans = availableColors.map(color => {
      const colorHex = colorMap[color.replace(' ', '').toLowerCase()] ; 
      if(colorHex){
        return `<span class='color-swatch-compare' style="background-color: ${colorHex}; padding: 0 10px; "></span>`;
      }else{
        return `<span class='color-swatch-compare' style="background-image: url('https://www.radpowerbikes.com/cdn/shop/files/${color.replace(/\s+/g, '-').toLowerCase()}_24x24.png'); padding: 0 10px;"></span>`;
      }
      
    });
  
    return colorSpans.join(" ");
  }
  

  getFeatureText(product, title) {
    const raw = product.included_features_details?.value;
    const parsed = raw ? this.safeParseJSON(raw) : [];
    if (!Array.isArray(parsed)) return "";

    for (const featureSet of parsed) {
      if (Array.isArray(featureSet)) {
        for (const feature of featureSet) {
          if (feature.title === title) {
            return feature.text;
          }
        }
      }
    }
    return "-";
  }

  getSpecText(product, title) {
    const raw = product.more_details_details?.value;
    const parsed = raw ? this.safeParseJSON(raw) : [];
    if (!Array.isArray(parsed)) return "";

    for (const detailSet of parsed) {
      if (Array.isArray(detailSet)) {
        for (const detail of detailSet) {
          if (detail.title === title) {
            return detail.text;
          }
        }
      }
    }
    return "-";
  }

  buildComparisonTable(products) {
    let html = "<tbody class='comparisonTbody'>";

    html += `<thead class='compare-table-head'>
      <div class='column-gap-2 d-flex d-md-none flex-column compare-table-main-content'>
        <div class="product-images-container row mx-n1 mx-md-n2 justify-content-center">
          ${products.map((p, i) => 
            `<div class='productCompareImage col-4 px-1 px-md-2 text-center' pId='${p.id}'>
              <div class="productCompareImage-bg ${i === 0 ? "border border-black rounded" : ""}">
                <img src="${p.featuredImage?.url ?? ""}" 
                  class="product-image productCompareImage" 
                  pId='${p.id}' 
                  alt="${p.title}"
                />
              </div>
            </div>`
          ).join("")}
          ${this.queryParams === 1 ? 
            `<div class='productCompareImage col-4 px-1 px-md-2 text-center d-flex align-items-center justify-content-center h4'><a href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' class="add_model"><svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model</a></div>
            <div class='productCompareImage col-4 px-1 px-md-2 text-center d-flex align-items-center justify-content-center h4'><a href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' class="add_model"><svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model</a></div>` : ""}
          ${this.queryParams === 2 ? 
            `<div class='productCompareImage col-4 px-1 px-md-2 text-center d-flex align-items-center justify-content-center h4'><a href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' class="add_model"><svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model</a></div>` : ""}
        </div>
        <div class="product-content-container gap-2">
          ${products.map((p, i) => 
            `<div pId='${p.id}' class='td-header-${i} product-col'>
              <h2 class='h4 my-4 compare-product-title td-${i} ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle' pId='${p.id}'>${p.title}</h2>
              <div class='d-flex flex-row gap-3 compare-product-button td-${i}'>
                <a href='${p.onlineStoreUrl}' class='btn btn-primary td-${i} ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle' pId='${p.id}'>
                 Shop Now
                </a>
                <button class='btn btn-outline-dark customRemoveClass td-${i} ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle' pId='${p.id}'>Remove</button>
              </div>
            </div>`
          ).join("")}
        </div>
      </div>
      <tr class='d-none d-md-table-row'>
        <th class='py-6 modelTh px-0 model-title-parent'><h1 class="h4">Model</h1></th>
        ${products
          .map((p, i) => {
            return `
              <td pId='${p.id}' class='pb-6 td-header-${i} product-col'>
                <div class="d-flex flex-column h-100">
                  <div class='productCompareImage productCompareImage-bg ' pId='${p.id}'> <img src="${p.featuredImage?.url ?? ""}" class="product-image productCompareImage"  pId='${p.id}' alt="${p.title}"/> </div> 
                
                </div>              </td>
            `;
          }) 
          .join("")}
        ${this.queryParams === 1 ? `<td class='text-center h5 '><a href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' class="add_model"><svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model</a></td><td class='text-center h5 ' ><a href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}'  class="add_model"><svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model</a></td>` : ""}
        ${this.queryParams === 2 ? `<td class='text-center h5 '><a href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' class="add_model"><svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model</a></td>` : ""}
      </tr>
            <tr class='d-none d-md-table-row  desktop-compare-product-title'>
              <th class='py-6 modelTh px-0 model-title-parent'><h1></h1></th>
        ${products
          .map((p, i) => {
            return `
              <td pId='${p.id}' class='pb-3 td-header-${i} product-col '>
                <div class="d-flex flex-column h-100">
                  <h2 class='h4 mt-4 td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle' pId='${p.id}'>${p.title}</h2>
          
                </div>
              </td>
            `;
          })
          .join("")}
         </tr>
            <tr class='d-none d-md-table-row'>
              <th class='py-6 modelTh px-0 model-title-parent'><h1></h1></th>
        ${products
          .map((p, i) => {
            return `
              <td pId='${p.id}' class='pb-6 td-header-${i} product-col'>
                <div class="d-flex flex-column h-100">
         
                  <div class='d-flex flex-column gap-3 td-${i}'>
                    <a href='${p.onlineStoreUrl}' class='btn btn-primary td-${i} ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle' pId='${p.id}'>
                    Shop Now
                    </a>
                    <button class='btn btn-outline-dark customRemoveClass td-${i} ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle' pId='${p.id}'>Remove</button>
                  </div>
                </div>
              </td>
            `;
          })
          .join("")}
       </tr>
    </thead>`;

    html += `<tr>
        <th><h4>Price </h4></th>
        ${products.map((p, i) => `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle  fw-medium compare-price-parent'>${this.getPriceRange(p)}</td>`).join("")}
      </tr>`;

    html += `<tr>
      <th><h4>Reviews</h4></th>
      ${products
      .map(
      (p, i) => 
      `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'> 
      ${p.review_average?.value || 0}
     <span class="stars">
  ${[...Array(5)].map((_, index) => {
    const fillPercentage = Math.min(Math.max(p.review_average?.value - index, 0), 1) * 100;
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <defs>
          <linearGradient id="starGradient-${p.id}-${index}" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="${fillPercentage}%" stop-color="#FFA500" />
            <stop offset="${fillPercentage}%" stop-color="#D3D3D3" />
          </linearGradient>
        </defs>
        <path fill="url(#starGradient-${p.id}-${index})" d="M9.10326 1.81699C9.47008 1.07374 10.5299 1.07374 10.8967 1.81699L12.7063 5.48347C12.8519 5.77862 13.1335 5.98319 13.4592 6.03051L17.5054 6.61846C18.3256 6.73765 18.6531 7.74562 18.0596 8.32416L15.1318 11.1781C14.8961 11.4079 14.7885 11.7389 14.8442 12.0632L15.5353 16.0931C15.6754 16.91 14.818 17.533 14.0844 17.1473L10.4653 15.2446C10.174 15.0915 9.82598 15.0915 9.53466 15.2446L5.91562 17.1473C5.18199 17.533 4.32456 16.91 4.46467 16.0931L5.15585 12.0632C5.21148 11.7389 5.10393 11.4079 4.86825 11.1781L1.94038 8.32416C1.34687 7.74562 1.67438 6.73765 2.4946 6.61846L6.54081 6.03051C6.86652 5.98319 7.14808 5.77862 7.29374 5.48347L9.10326 1.81699Z"/>
      </svg>
    `;
  }).join("")}
</span>

        (${p.review_count?.value || 0} reviews )
      </td>`
      )
      .join("")}
    </tr>`;

    html += `<tr> 
        <th><h4>Available Colors</h4></th>
      ${products.map((p, i) => `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'>${this.getColors(p) || '-'}</td>`).join("")}
      </tr>`;

    html += `<tr>
      <th><h4>Product Description</h4></th>
      ${products.map((p, i) => {
        const plainTextDescription = p.descriptionHtml ? p.descriptionHtml.replace(/<[^>]*>/g, '').split('Range')[0] : '-';
        return `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'>${plainTextDescription}</td>`;
      }).join("")}
      </tr>`;
      
    html += `<tr>
      <th><h4>Rider Height</h4></th>
      ${products
        .map(
          (p, i) => 
            `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'>
              ${p.step_thru_description?.value ? p.step_thru_description.value : "-"}
            </td>`
        )
        .join("")}
    </tr>`;
"<p data-mce-fragment=\"1\"><span data-mce-fragment=\"1\">Top speed: <br>Class 1 &amp; 2: Up to 20 mph<br>Class 3 (limited): Up to 25 mph<br>Class 3: Up to 28 mph</span></p>"

    const specs = {};
    products.map((p, index) => {
      console.log(p, 'pppp');
      const description = p.descriptionHtml;
      const matches = description.match(/<p.*?>(.*?)<\/p>/g);
      console.log(matches, 'matches');

      matches.forEach(match => {
        const text = match.replace(/<.*?>/g, '');
        console.log(text.split(/:\s*/), 'matchhhhhhhh');
        
        const [key, value] = text.split(/:\s*/);

        if (key && value) {
          if (!specs[key]) {
            specs[key] = [];
          }
          specs[key][index] = value.trim();
        }
      });
    });
    console.log(specs, 'specs');
    
    Object.entries(specs).forEach(([key, values]) => {
      console.log(products, 'products');
      if (key === 'Description') return;
      html += `<tr><th><h4>${key}</h4></th>`;
      products.forEach((each, index) => {
        html += `<td pId='${each.id}' class='td-${index} ${index === 1 || index === 2 ? "tdHidden" : ""} tdToggle xxxx'>${values[index] || '-'}</td>`; 
      });
      html += `</tr>`;
    });

    const featureTitles = new Set();
    products.forEach(product => {
      const raw = product.included_features_details?.value;
      const parsed = raw ? this.safeParseJSON(raw) : [];
      if (Array.isArray(parsed)) {
        parsed.forEach(featureSet => {
          if (Array.isArray(featureSet)) {
            featureSet.forEach(feature => {
              featureTitles.add(feature.title);
            });
          }
        });
      }
    });
    html += `<tr>
      <th><h4>Warranty</h4></th>
      ${products
        .map(
          (p, i) => 
            `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'>
           <svg aria-hidden="true" focusable="false" height="24" width="24" class="me-2"><use href="#warranty"></use></svg>   2 years warranty
            </td>`
        )
        .join("")}
    </tr>`;
    const featureList = Array.from(featureTitles);

    html += `
        <tr>
          <th colspan="${products.length + 1}" class="section-heading accordion-header features h3 py-6 py-md-8 py-lg-10">
            <svg aria-hidden="true" focusable="false" class="me-3">
              <use href="#icon-arrow-down"></use>
            </svg>
            Included Features
          </th>
        </tr>
        ${featureList.map((title, i) => 
          `<tr class='accordion-content active features'>
            <th class='test'><h4>${title}</h4></th>
            ${products.map((p, i) => `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'>${this.getFeatureText(p, title) || '-'}</td>`).join("")}
          </tr>`
        ).join("")}
      `;

    const specTitles = new Set();
    products.forEach(product => {
      const raw = product.more_details_details?.value;
      const parsed = raw ? this.safeParseJSON(raw) : [];
      if (Array.isArray(parsed)) {
        parsed.forEach(detailSet => {
          if (Array.isArray(detailSet)) {
            detailSet.forEach(detail => {
              specTitles.add(detail.title);
            });
          }
        });
      }
    });

    const specList = Array.from(specTitles);

    html += `
        <tr>
          <th colspan="${products.length + 1}" class="section-heading accordion-header moreDetails h3 py-6 py-md-8 py-lg-10">
            <svg aria-hidden="true" focusable="false" class="me-3">
              <use href="#icon-arrow-down"></use>
            </svg>
            More Details
          </th>
        </tr>
        ${specList.map(title => 
          `<tr class='accordion-content active moreDetails'>
            <th><h4>${title}</h4></th>
            ${products.map((p, i) => `<td pId='${p.id}' class='td-${i}  ${i === 1 || i === 2 ? "tdHidden" : ""} tdToggle'>${this.getSpecText(p, title) || '-'}</td>`).join("")}
          </tr>`
        ).join("")}
      `;

    html += "</tbody>";

    return html;
  }

  async fetchProductMetafields() {
    const urlParamsCompare = new URLSearchParams(window.location.search);
    const vids = urlParamsCompare.get("vids") ? urlParamsCompare.get("vids").split(",") : [];

    if (vids.length === 0) return;

    const gqlIds = vids.map(id => `gid://shopify/Product/${id}`);
    console.log("Formatted Shopify Global IDs:", gqlIds);

    const gqlQuery = JSON.stringify({
      query: `
        {
            nodes(ids: ["${gqlIds.join('","')}"]) {
                ... on Product {
                    id
                    handle
                    title
                    descriptionHtml
                    availableForSale
                    onlineStoreUrl
                    featuredImage { url }
                    variants(first: 20) {
                        edges {
                            node {
                                id
                                title
                                availableForSale
                                compareAtPriceV2 { amount }
                                priceV2 { amount }
                                image { url }
                                selectedOptions {
                                    name
                                    value
                                }
                                hideVariant: metafield(key: "hide_variant_option", namespace: "accentuate") {
                                    value
                                }
                            }
                        }
                    }
                    options {
                        name
                        values
                    }
                    common_title: metafield(key: "commontitle", namespace: "marketing") { value }
                    product_description: metafield(key: "product_description", namespace: "sh2") { value }
                    high_step_description: metafield(key: "high_step_short_description", namespace: "sh2") { value }
                    mid_step_description: metafield(key: "mid_step_short_description", namespace: "sh2") { value }
                    step_thru_description: metafield(key: "step_thru_short_description", namespace: "sh2") { value }
                    large_description: metafield(key: "large_short_description", namespace: "sh2") { value }
                    regular_description: metafield(key: "regular_short_description", namespace: "sh2") { value }
                    review_count: metafield(key: "review_count", namespace: "reviews") { value }
                    review_average: metafield(key: "review_average", namespace: "reviews") { value }
                    included_features_frame_style: metafield(key: "included_features_frame_style", namespace: "sh2") { value }
                    included_features_details: metafield(key: "included_features_details", namespace: "sh2") { value }
                    more_details_frame_style: metafield(key: "more_details_frame_style", namespace: "sh2") { value }
                    more_details_details: metafield(key: "more_details_details", namespace: "sh2") { value }
                    product_rider_height: metafield(key: "product_rider_height", namespace: "accentuate") { value }
                    value_prop_detail: metafield(key: "value_prop_detail", namespace: "buy_box") { value }
                }
            }
        }
      `
    });

    const response = await fetch("https://www.radpowerbikes.com/api/2024-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "a89f90cd9f95656d573c49d318c7a616"
      },
      body: gqlQuery
    });

    const data = await response.json();
    console.log("GraphQL Response:", data);
    if (!data.data || !data.data.nodes || data.data.nodes.every(node => node === null)) {
      console.error("No valid products found.");
      document.querySelector("#comparison-container").innerHTML = "<p>No products found.</p>";
      return;
    }

    const products = data.data.nodes.filter(node => node !== null);

    const comparisonTable = document.getElementById("comparison-container");
    if (comparisonTable) comparisonTable.innerHTML = this.buildComparisonTable(products);
  }

  handleDocumentClick(event) {
    if (event.target.classList.contains("productCompareImage")) {
      let target = event.target.getAttribute('pid');
      document.querySelectorAll('.tdToggle').forEach(eachh => {
        eachh.classList.add('tdHidden');
        if (target === eachh.getAttribute('pid')) {
          eachh.classList.remove('tdHidden');
          console.log(eachh, 'target');
          document.querySelectorAll('.productCompareImage-bg').forEach(each => {
            each.classList.remove("border", "border-black", "rounded");
          })
         
          const imageBg = event.target.querySelector('.productCompareImage-bg');
          if (window.innerWidth < 1200) {
          if (imageBg) {
            imageBg.classList.add("border", "border-black", "rounded");
          }
            
          const closestImageBg = event.target.closest('.productCompareImage-bg');
            console.log(imageBg, closestImageBg, 'klklklklklklklk')
          if (closestImageBg) {
            closestImageBg.classList.add("border", "border-black", "rounded");
            
          }
        }
        }
      });
    }
    if (event.target.classList.contains("customRemoveClass")) {
      var target = event.target.getAttribute("pid");
      console.log("Target PID:", target);

      let removed = false;

      document.querySelectorAll("#comparison-container td, div.productCompareImage").forEach(each => {
        if (target === each.getAttribute("pid")) {
          each.remove();
          removed = true;
        }
      });
      document.querySelector('.productCompareImage')?.click();

      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);

      let vids = params.get("vids")?.split(",") || [];

      console.log("Before Removal:", vids);

      let targetId = target.split("/").pop();
      vids = vids.filter(val => val !== targetId);

      console.log("After Removal:", vids);

      if (vids.length) {
        params.set("vids", vids.join(","));
      } else {
        params.delete("vids");
      }
      
      let newUrl = url.pathname + "?" + params.toString();
      console.log("Updated URL Params:", newUrl)
      window.history.replaceState(null, "", newUrl);
      if (removed) {
        const comparisonRow = document.querySelector('#comparison-container tr');
        if (comparisonRow) {
          if (window.innerWidth >= 1200) {
            const newTd = document.createElement("td");
            newTd.innerHTML = `<a class='add_model' href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' > <svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model </a>`;
            newTd.classList.add("new-data-td");
            newTd.classList.add("text-center");
            newTd.classList.add("h5");
            comparisonRow.appendChild(newTd);
          } else {
            const comparisonRows = document.querySelector('.product-images-container');
            const newTd = document.createElement("div");
            newTd.innerHTML = `<a class='add_model' href='https://www.radpowerbikes.com/collections/electric-bikes${window.location.search}' > <svg aria-hidden="true" focusable="false" class="mb-2"><use href="#icon-plus"></use></svg>Add a model </a>`;
            newTd.classList.add("new-data-td");
            newTd.classList.add(
              "text-center",
              "productCompareImage",
              "col-4",
              "px-1",
              "px-md-2",
              "d-flex",
              "align-items-center",
              "justify-content-center",
              "h4"
            );
            newTd.classList.add("h5");
            comparisonRows.appendChild(newTd);
          }
        }
      }
      if (!window.location.href.includes('vids=')) {
        document.querySelector('.emptyComparePage').classList.remove('d-none');
        document.querySelector('#comparison-container').classList.add('d-none');
        document.querySelector('.customBackDiv').classList.add('d-none');
      }

      if (document.querySelector('.selectedCount')) document.querySelector('.selectedCount').innerHTML = vids.length;
      this.toggleCompareButton();
    }
    if (event.target.classList.contains('accordion-header') && event.target.classList.contains('features')) {
      document.querySelectorAll('.features').forEach(each => {
        each.classList.toggle('active');
      });
    }
    if (event.target.classList.contains('accordion-header') && event.target.classList.contains('moreDetails')) {
      document.querySelectorAll('.moreDetails').forEach(each => {
        each.classList.toggle('active');
      });
    }
  }

  initialize() {
    if (document.querySelector('.selectedCount')) document.querySelector('.selectedCount').innerHTML = this.queryParams;

    document.querySelector('.clearAllButton')?.addEventListener('click', this.handleClearAllClick);
    document.querySelector('.CompareFooter')?.addEventListener('click', this.handleCompareFooterClick);
    document.addEventListener("click", this.handleDocumentClick);

    this.initializeFromURL();
    this.toggleCompareButton();
    this.setupMutationObserver();

    this.fetchProductMetafields();
    this.headerTopHeight()
 
  }
}

const productComparison = new ProductComparison();